import { isSdkSupported } from 'utilities/sdk-support/isSdkSupported';

export const isSupported = isSdkSupported;
